import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  createNewList,
  retrieveListDetails,
} from "../../networking/new-list/networking";
import * as types from "../types/new-list";

function* fetchListDetails(action) {
  try {
    const details = yield call(retrieveListDetails, action.body);
    if (Object.keys(details).length > 0) {
      yield put({ type: types.SET_LIST_SIZE, size: details.payload.size });
      yield put({ type: types.SET_API_URL, url: details.payload.url });
    } else {
      if (details === "error") {
        throw new Error("Kunne ikke hente listedata.");
      } else {
        throw new Error("Kunne ikke hente listedata.");
      }
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_LIST_SIZE,
      message: "Kunne ikke hente data.",
    });
  }
}

function* performAddNewList(action) {
  try {
    if (action.details) {
      const response = yield call(createNewList, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_NEW_LIST });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke opprette ny liste.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_ADD_NEW_LIST,
      message: "Kunne ikke opprette liste.",
    });
  }
}

function* newListSaga() {
  yield all([
    takeEvery(types.REQUEST_LIST_SIZE, fetchListDetails),
    takeEvery(types.REQUEST_ADD_NEW_LIST, performAddNewList),
  ]);
}

export default newListSaga;
